import request from '@/axios/index.js'
const uri = '/user/circle/';
export function circleQuery(data,loading) {
    return request.axios({
        url: uri+'query',
        data: data,
        loading:loading
    })
}
export function circleGet(data,loading) {
    return request.axios({
        url: uri+'get',
        data: data,
        loading:loading
    })
}

export function circleUserInfo(data,loading) {
    return request.axios({
        url: uri+'userInfo',
        data: data,
        loading:loading
    })
}

export function circleAdd(data,loading) {
    return request.axios({
        url: uri+'add',
        data: data,
        loading:loading
    })
}
export function addRecommend(data,loading) {
    return request.axios({
        url: uri+'save',
        data: data,
        loading:loading
    })
}






// WEBPACK FOOTER //
// ./src/api/circle.js